import React, { useEffect, useState } from "react";
import Input from "../../input/Input";
import SearchDropdown from "../../input/SearchDropdown";
import {
  getBulkDropdownData,
  getOtherRefDetails,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import Button from "../../input/Button";
import Dropdown from "../../input/Dropdown";
import { Search } from "react-feather";
import LoadingSpinner from "../../LoadingSpinner";
import { toast } from "react-toastify";
import { localStorageKeys } from "../../../const";

const BatchChargeSearch = ({
  searchResHandler,
  resetHandler,
  activeAccordion2,
  setActiveAccordion2,
}) => {
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [chargeType, setChargeType] = useState(1);
  const [jobNos, setJobNos] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [dateType, setDateType] = useState("");
  const [dateTypeOpt, setDateTypeOpt] = useState([]);

  const [customer, setCustomer] = useState([]);
  const [transporter, setTransporter] = useState("");
  const [veh, setVeh] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [reloadDates, setReloadDates] = useState(true);
  const [resetSearchFields, setResetSearchFields] = useState(false);

  const [chargeTypeOptions, setChargeTypeOptions] = useState([]);

  const [currentErrors, setCurrentErrors] = useState({});

  useEffect(() => {
    if (reloadDates) {
      const aWeekAgo = new Date();
      aWeekAgo.setDate(aWeekAgo.getDate() - 7);
      const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
      const formattedToday = new Date().toISOString().split("T")[0];
      setFromDate(formattedWeekAgo);
      setToDate(formattedToday);
    }
    setReloadDates(false);
  }, [reloadDates]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const { rate_type_for: chargeTypeOpt, date_types: dateTypeData } =
        await getBulkDropdownData([
          { key: "rate_type_for" },
          { key: "date_types" },
        ]);
      setChargeTypeOptions(chargeTypeOpt);
      setDateTypeOpt(dateTypeData);
      setIsLoading(false);
    })();
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    localStorage.removeItem(localStorageKeys.CHARGE_LIST_VIEW);
    if (!chargeType) {
      setCurrentErrors((prevState) => ({
        ...prevState,
        chargeType: "Batch Type is Mandatory",
      }));
      toast.warn("Batch Type is Mandatory", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    searchResHandler({
      dDateType: dateType ? dateType : null,
      dFromDate: fromDate,
      dToDate: toDate,
      sTransporter: transporter.toString(),
      sBatchType: chargeType.toString(),
      sJobs: jobNos,
      sBatchNumber: batchNo,
      sCustomer: customer && customer.length > 0 ? customer.join(",") : "",
      sVehicle: veh && veh.length > 0 ? veh.join(",") : "",
    });
  };

  const onReset = (e) => {
    e.preventDefault();
    setResetSearchFields(true);
    setVeh([]);
    setCustomer([]);
    setChargeType(1);
    setBatchNo("");
    setDateType("");
    setJobNos("");
    setTransporter("");
    setReloadDates(true);
    resetHandler();
  };

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion2 ? "active" : ""}`}
            onClick={() => setActiveAccordion2(!activeAccordion2)}
          >
            <div>
              Search
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>
          </div>
          <div className={`content ${activeAccordion2 ? "active" : ""}`}>
            <form className="ui form">
              <h4 className="ui dividing header">Batch Charge Search</h4>
              <div
                className="four fields"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Dropdown
                  required={true}
                  error={currentErrors.chargeType}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { chargeType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={chargeTypeOptions}
                  label="Charge Type"
                  value={chargeType}
                  onChange={(e, data) => {
                    setChargeType(data.value);
                  }}
                />
                <Dropdown
                  // required={true}
                  options={dateTypeOpt}
                  label="Date Type"
                  placeholder="Date Type"
                  style={{ height: "20px" }}
                  value={dateType}
                  onChange={(e, data) => {
                    setDateType(data.value);
                  }}
                  clearable={false}
                />
                <Input
                  label="From Date"
                  type="date"
                  name="fromDate"
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                  }}
                />

                <Input
                  label={"To Date"}
                  type="date"
                  name="toDate"
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                  }}
                />
              </div>
              <div
                className="three fields"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div className="field">
                  <label>Batch Numbers</label>
                  <input
                    type="text"
                    placeholder="Batch Numbers"
                    name="batchnos"
                    value={batchNo}
                    onChange={(e) => {
                      setBatchNo(e.target.value);
                    }}
                  />
                </div>
                {/* <Input
                  label="Batch Number"
                  type="text"
                  placeholder="Batch Number"
                  name="jobnos"
                  value={batchNo}
                  onChange={(e) => {
                    setBatchNo(e.target.value);
                  }}
                /> */}
                {/* <Input
                  label="Job Numbers"
                  type="text"
                  placeholder="Example - 1,2,3"
                  name="jobnos"
                  value={jobNos}
                  onChange={(e) => {
                    setJobNos(e.target.value);
                  }}
                /> */}
                <div className="field">
                  <label>Job Numbers</label>
                  <input
                    type="text"
                    placeholder="Ex:JOB-0000123,JOB-0000124"
                    name="jobnos"
                    value={jobNos}
                    onChange={(e) => {
                      setJobNos(e.target.value);
                    }}
                  />
                </div>
                <SearchDropdown
                  key={2}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  onResultSelect={(data) => {
                    setTransporter(data);
                  }}
                  clearable={true}
                  onClear={() => {
                    setTransporter("");
                  }}
                  api={getOtherRefDetails}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Transporter",
                  }}
                  label="Transporter"
                />
              </div>
              <div
                className="two fields"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <SearchDropdown
                  key={1}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  onResultSelect={(data) =>
                    setCustomer((prev) => [...prev, data])
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Customer",
                  }}
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setCustomer((prev) =>
                      prev.filter((item) => item !== parseInt(key))
                    );
                  }}
                  label="Customer"
                />
                <SearchDropdown
                  key={1}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  onResultSelect={(data) => setVeh((prev) => [...prev, data])}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "vehicle",
                    value: "",
                  }}
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setVeh((prev) =>
                      prev.filter((item) => item !== parseInt(key))
                    );
                  }}
                  label="Vehicle"
                />
              </div>
              <div className="field">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button template="search" onClick={onSearch} />
                    <Button template="searchReset" onClick={onReset} />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default BatchChargeSearch;
